import { create } from "zustand";
import { URL } from "../../lib/apis";

interface CartState {
  orderDetail: any | null; // Initialise à null pour éviter les erreurs au chargement
  loadingDetail: boolean;
  fetchOrderDetail: (order_id: string) => Promise<void>;
}

const useOrderDetail = create<CartState>((set) => ({
  orderDetail: null, // Initialise à null avant le chargement des données
  loadingDetail: false,

  fetchOrderDetail: async (order_id: string) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user");

    if (!token) {
      console.error("User is not authenticated");
      return;
    }

    set({ loadingDetail: true });

    try {
      const response = await fetch(
        `${URL}/users/${userId}/orders/${order_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch categories: ${response.statusText}`);
      }

      const data = await response.json();
      set({ orderDetail: data.orders, loadingDetail: false }); // On assigne directement 'data' sans 'data.data'
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error fetching categories:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loadingDetail: false });
    }
  },
}));

export default useOrderDetail;
